import React from 'react';

import Layout from '../../components/Layout';
import SEO from '../../components/SEO';

import MainHeroMassage from '../../components/HomeSections/MainHeroMassage';
import We from '../../components/HomeSections/we';
import Principios from '../../components/HomeSections/principios';
import Areas from '../../components/HomeSections/areas';
import Trademarks from '../../components/HomeSections/trademarks';
import Sustentabilidad from '../../components/HomeSections/sustentabilidad';
// import Experiencia from '../../components/HomeSections/experiencia';

export default function index() {
	return (
		<Layout page='home'>
			<SEO title='Trabaja en CCU Argentina' />
			<MainHeroMassage />
			<We />
			<Principios />
			<Areas />
			<Trademarks />
			<Sustentabilidad />
			{/* <Experiencia /> */}
		</Layout>
	);
}
